import { memo } from 'react';
import image from '../../images/brand-logo.png';
import { Stack, StackProps } from '@mui/material';

export type FooterProps = {
  sx?: StackProps['sx'];
};

const Footer = memo((props: FooterProps) => (
  <Stack
    className="nd-footer"
    sx={{ marginX: 'auto', textAlign: 'center', padding: '15px', ...props.sx }}
    direction="row"
    alignItems="center"
    justifyContent="center"
  >
    <span>
      <a target="_blank" rel="noreferrer" href="http://www.inmarket.com">
        <img src={image} alt="InMarket logo" />
      </a>
    </span>
    <span>
      &copy; {new Date().getFullYear()} by InMarket, Inc. All Rights Reserved.
    </span>
    <span>
      <a
        target="_blank"
        rel="noreferrer"
        href="http://www.inmarket.com/privacy/"
        style={{ textDecoration: 'none' }}
      >
        Privacy Policy &amp; Terms of Service
      </a>
    </span>
  </Stack>
));

Footer.displayName = 'Footer';

export default Footer;
